<template>
    <div>
        <img :src="url_image" alt="" class="text-center" :class="formatting" :width="width">
    </div>
</template>

<script>
export default {
    props: [
        'formatting',
        'width'
    ],

    data(){
        return {
            url_image:''
        }
    },

   mounted(){
     this.url_image =process.env.VUE_APP_LOGO_NEGATIVE
   }
}
</script>

<style></style>